import styled from 'styled-components';
import { animated } from 'react-spring';

export const BoxWrapper = styled.div`
  position: relative;
  height: 160px;
  width: 144px;
  border: 1px solid ${({ theme }) => theme.colors.neutral[100]};
  border-radius: 2px;
  background-color: ${({ theme }) => theme.colors.neutral[25]};
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.2s;

  &:hover {
    cursor: pointer;
    border: 1px solid ${({ theme }) => theme.colors.neutral[700]};
    background-color: ${({ theme }) => theme.colors.neutral[100]};
  }
`;

export const InnerItemContainer = styled.div`
  height: 142px;
  width: 126px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Image = styled.img`
  object-fit: contain;
  height: 100%;
  width: 100%;
`;

export const ItemInformationCard = styled(animated.div)`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  height: 47px;
  width: 144px;
  padding: 8px;
  position: absolute;
  bottom: 0;
  z-index: 10;
  border-left: 1px solid ${({ theme }) => theme.colors.neutral[700]};
  border-right: 1px solid ${({ theme }) => theme.colors.neutral[700]};
  border-bottom-left-radius: 2px;
  border-bottom-right-radius: 2px;
  background-color: ${({ theme }) => theme.colors.neutral[0]};
  box-shadow: 0px -2px 7px rgba(0, 0, 0, 0.08);

  &:hover {
    text-overflow: clip;
    white-space: normal;
    height: auto;
  }
`;

export const ItemNameContainer = styled.div`
  min-height: 18.5px;
`;
